<template>
  <v-container id="dashboard" fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="headline font-weight-bold">Select to view order History</v-subheader>
        </div>
      </v-col>
      <v-col v-for="item in KIT" :key="item.id" cols="12" sm="6" md="4" lg="3">
        <router-link :to="{ name: 'KitOrderHistory', params: { kitType: item.route } }" :title="item.name">
          <clickable-card :icon="item.icon" gotoIcon="mdi-arrow-top-right" :color="item.colorIcon" :cardTitle="item.name"> </clickable-card>
        </router-link>
      </v-col> </v-row
  ></v-container>
</template>
<script>
import constants from '@/utils/constants'
import ClickableCard from '@/components/template/ClickableCard'

export default {
  name: 'orderHistoryTab',
  components: { ClickableCard },
  data () {
    return {
      KIT: constants.KIT
    }
  }
}
</script>
